import React from 'react';
import { useTranslation } from 'react-i18next';
import { TitleIcon, ArrowRightIcon, RiskManagementIcon, SeamlessIntegrationIcon, DeepAnalysisEngineIcon } from '../constants.tsx';
import AnimatedParticles from './AnimatedParticles.tsx';

const FeatureList: React.FC = () => {
    const { t } = useTranslation();
    return (
        <section className="pt-12.5">
            <div className="max-w-6xl mx-auto px-4 sm:px-8 xl:px-0">
                <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
                    
                    <div className="md:col-span-12">
                        <div className="relative rounded-3xl features-box-border">
                            <div className="relative overflow-hidden rounded-3xl p-10 xl:p-15 box-hover">
                                <AnimatedParticles />
                                <div className="absolute -z-1 pointer-events-none inset-0">
                                    <div className="absolute ltr:left-0 rtl:right-0 bottom-0 w-[500px] h-[500px] bg-purple-900/50 rounded-full blur-[120px]"></div>
                                </div>
                                <div className="flex items-center justify-between relative z-20 flex-wrap gap-10">
                                    <div className="max-w-md w-full">
                                        <span className="hero-subtitle-gradient relative mb-4 font-medium text-sm inline-flex items-center gap-2 py-2 px-4.5 rounded-full">
                                            <TitleIcon />
                                            <span className="hero-subtitle-text">{t('featureListSubtitle1')}</span>
                                        </span>
                                        <h3 className="text-white mb-4.5 font-bold text-3xl">{t('featureListTitle1')}</h3>
                                        <p className="font-medium mb-10">
                                            {t('featureListDescription1')}
                                        </p>
                                        <a href="#" className="hero-button-gradient relative inline-flex items-center gap-1.5 rounded-full py-3 px-6 text-white text-sm ease-in duration-300 hover:opacity-80">
                                            {t('learnMore')}
                                            <ArrowRightIcon />
                                        </a>
                                    </div>
                                    <div className="max-w-xs w-full hidden sm:block">
                                        <DeepAnalysisEngineIcon />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="md:col-span-7">
                        <div className="relative rounded-3xl features-box-border h-full">
                            <div className="relative overflow-hidden rounded-3xl px-11 pt-12.5 pb-14 box-hover-small h-full">
                               <AnimatedParticles />
                               <div className="absolute -z-1 pointer-events-none inset-0">
                                    <div className="absolute ltr:left-0 rtl:right-0 bottom-0 w-[300px] h-[300px] bg-indigo-900/50 rounded-full blur-[100px]"></div>
                                     <div className="absolute ltr:right-0 rtl:left-0 top-0 w-[300px] h-[300px] bg-fuchsia-900/50 rounded-full blur-[100px]"></div>
                                </div>
                                <div className="relative z-20">
                                    <span className="icon-border relative max-w-[80px] w-full h-20 rounded-full inline-flex items-center justify-center mb-13.5">
                                        <RiskManagementIcon />
                                    </span>
                                    <h3 className="text-white mb-4.5 font-semibold text-xl">{t('featureListTitle2')}</h3>
                                    <p className="font-medium">
                                        {t('featureListDescription2')}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div className="md:col-span-5">
                        <div className="relative rounded-3xl features-box-border h-full">
                            <div className="relative overflow-hidden rounded-3xl px-11 pt-12.5 pb-14 box-hover-small h-full">
                                <AnimatedParticles />
                                <div className="absolute -z-1 pointer-events-none inset-0">
                                    <div className="absolute ltr:right-0 rtl:left-0 top-0 w-[300px] h-[300px] bg-pink-900/50 rounded-full blur-[100px]"></div>
                                </div>
                                <div className="relative z-20">
                                    <span className="icon-border relative max-w-[80px] w-full h-20 rounded-full inline-flex items-center justify-center mb-13.5">
                                        <SeamlessIntegrationIcon />
                                    </span>
                                    <h3 className="text-white mb-4.5 font-semibold text-xl">{t('featureListTitle3')}</h3>
                                    <p className="font-medium">
                                        {t('featureListDescription3')}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </section>
    );
};

export default FeatureList;